
  import { Vue, Component, Prop } from "vue-property-decorator";

  import AuthCard from "@/components/auth/AuthCard.vue";
  import AuthFormLink from "@/components/auth/AuthFormLink.vue";
  import RouteNames from "@/entities/RouteNames";

  import { User } from "@/generated/graphql"

  @Component({
    components: {
      AuthFormLink,
      AuthCard
    }
  })
  export default class AuthWarning extends Vue {
    @Prop({type: String, required: true}) readonly title!: User;
    @Prop({type: String, required: true}) readonly message!: User;

    signOut(): void {
      this.$router.push({
        name: RouteNames.SIGNOUT,
      });
    }
  }
